import { Bell, CalendarDays } from 'lucide-react';

/**
 * The firm app's own areas of the profile (after Corly, ADR-042): how the firm reaches the
 * person - the calendar says WHEN, the notifications say ON WHICH WAY.
 */
export const FIRM_PROFILE_GROUPS = [
  {
    key: 'reach',
    title: 'Termine & Mitteilungen',
    areas: [
      {
        slug: 'calendar',
        title: 'Kalender',
        description: 'Ihre Fristen und Termine als Abo im eigenen Kalender.',
        icon: CalendarDays,
      },
      {
        slug: 'notifications',
        title: 'Benachrichtigungen',
        description: 'Was Sie zusätzlich per E-Mail bekommen.',
        icon: Bell,
      },
    ],
  },
] as const;
